import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import {
  Wrapper,
  Caption,
  CommandCard,
  CodeText
} from './styled';

const CodeBlock = ({ captionId = '', snippet }) => {
  const intl = useIntl();
  const snippetNode = <CodeText>{snippet}</CodeText>;

  return (
    <Wrapper>
      {captionId && <Caption>{intl.formatMessage({ id: captionId })}</Caption>}
      <CommandCard copyValue={ snippet } text={ snippetNode } />
    </Wrapper>
  );
};

CodeBlock.propTypes = {
  captionId: PropTypes.string,
  snippet: PropTypes.string.isRequired
};

export default CodeBlock;
